import constant from '../../constant';
import request from '../../../utils/request';
import { getUserKey } from '../../../utils/yUtil'
import { GET_SMP_UI_DATA } from '../../../urls'

const getSmpUIAbData = (params = {}) => {

  return async (dispatch) => {
    try {
      if (window._configs && window._configs.smpData && window._configs.smpData.pageId) {
        return  window._configs.smpData
      }
      const res = await request.get(GET_SMP_UI_DATA, {
        guid: getUserKey()
      })

      if (res.code === 0) {
        const data = res.data || {}
        // 上报url存在全局变量
        if (data && data.stat) {
          window.SMP_STAT_URL = data.stat
        }

        // 顶bar实验 
        if(data && !data['sharelp_smp_top_bar']) {
          data['sharelp_smp_top_bar'] = {
            data: {
              orders: [0, 1]  //默认展示 品牌向
            },
            style: {}
          }
        }

        // 阅读全文弹窗实验
        if(data && !data['sharelp_smp_read_dialog']) {
          data['sharelp_smp_read_dialog'] = {
            data: {
              orders: [0, 1] // 默认展示 系统弹窗
            },
            style: {}
          }
        }

        dispatch(getSmpUIAbDataSuccess(data))
      }
      
    } catch (error) {
      console.log('getSmpUIData error', error)
    }
  }
}


const getSmpUIAbDataSuccess = (data = {}) => {
  return {
    type: constant.SMP.GET_SMP_UI_DATA,
    data
  }
}

export default {
  getSmpUIAbData
}